// extracted by mini-css-extract-plugin
module.exports = {"playButton":"index__playButton__dGjwI","lock":"index__lock__QDAR1","playIcon":"index__playIcon__Pg3R-","lockIcon":"index__lockIcon__MjJcZ"};